import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const isMobileDevice = () =>
  /Android|iPhone|iPad|iPod|Mobile/i.test(navigator.userAgent);

const routes = [
  {
    path: "/",
    name: "home",
    component: () => import("../views/pc/home_page.vue"),
  },
  {
    path: "/homeMobile",
    name: "homeMobile",
    component: () => import("../views/mobile/home_mobile_page.vue"),
  },
  {
    path: "/share/:command",
    name: "shareLink",
    component: () => import("../views/mobile/command_file_list_page.vue"),
  },
  {
    path: "/shares/:command",
    name: "sharesLink",
    component: () => import("../views/mobile/copy_link_file_list_page.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  // mode: "hash",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  console.log(to.path);
  // if (to.path.startsWith("/share/")) {
  //   const command = to.path.replace("/share/", "");
  //   next({ name: "shareLink", query: { command }, replace: true });
  //   return;
  // }
  if (isMobileDevice() && to.name === "home") {
    next({ name: "homeMobile", replace: true });
    return;
  }
  if (!isMobileDevice() && to.name === "homeMobile") {
    next({ name: "home", replace: true });
    return;
  }
  next();
});

export default router;
